export default {
    companyTerms: {
        required: true,
    },
    privateTerms: {
        required: true,
    },
    personId: {
        optional_ssn: true
    } 
}